module.exports = __webpack_public_path__ + "img/question.a46184d9.png";